import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import SharedProviders_0_0 from './extensions/fe406f8a7d2a02b4ee5f557570919893f829838cf61d5bd542324bf715aaddf0/providers';
import SharedProviders_1_0 from './extensions/shipping-method-detail/provider';
import SharedProviders_2_0 from './extensions/8ea6febec06a8832db453c565a29192184b927fc68e4134ae037ab755e11a226/providers';
import SharedProviders_3_0 from './extensions/f8182fc8c8bfa724441d61193be394314274b0e319764bbeb208e934fd317153/providers';
import SharedProviders_4_0 from './extensions/b2bb9a48868bc52eb47eb0151a84d2fd8e585f5da3b08af22cd6f6019d686168/providers';
import SharedProviders_5_0 from './extensions/e52d94d9087795a184af3a94e69e34d91ed3c8b73b13a0eca48d7f25fb5560fa/providers';
import SharedProviders_6_0 from './extensions/eb9aabb4ea8c9a4acdbc51a5c9b02c65188c6423a690793abeacb9aa55e40064/providers';
import SharedProviders_7_0 from './extensions/seller-info/providers';
import SharedProviders_8_0 from './extensions/3d9fb0705cad9cf6352c3e0af9e11478758a3294ae0d576d66b4c832c17be0d2/providers';
import SharedProviders_10_0 from './extensions/multivendor-plugin/providers';
import SharedProviders_11_0 from './extensions/google-merchant/providers';
import SharedProviders_12_0 from './extensions/certificationAndChartsUI/provider';
import SharedProviders_13_0 from './extensions/chat-widget-vendure-plugin/providers';


@NgModule({
    imports: [CommonModule, ],
    providers: [...SharedProviders_0_0, ...SharedProviders_1_0, ...SharedProviders_2_0, ...SharedProviders_3_0, ...SharedProviders_4_0, ...SharedProviders_5_0, ...SharedProviders_6_0, ...SharedProviders_7_0, ...SharedProviders_8_0, ...SharedProviders_10_0, ...SharedProviders_11_0, ...SharedProviders_12_0, ...SharedProviders_13_0],
})
export class SharedExtensionsModule {}
